module.exports = __webpack_public_path__ + "static/media/BOT-3.713bc719.png";